import axios from "axios";
import {isAccessTokenValid, tryRefreshToken} from "@/utils/auth";

const getBaseURL = () => {
  if (import.meta.env.PROD) {
    return import.meta.env.VITE_API_BASE_URL || window.location.origin;
  }
  if (import.meta.env.STAGING) {
    return import.meta.env.VITE_API_BASE_URL || window.location.origin;
  }
  return import.meta.env.VITE_API_BASE_URL || 'http://localhost:5244';
};


const instance = axios.create({
    baseURL: getBaseURL() + '/api',
    headers: {
        'Content-Type': 'application/json'
    },
    timeout: 10000,
})

instance.interceptors.request.use(async (config) => {
    const token = localStorage.getItem('accessToken');

    if (token && isAccessTokenValid()) {
        config.headers.Authorization = `Bearer ${token}`;
    } else if (token) {
        try {
            const refreshed = await tryRefreshToken();
            if (refreshed) {
                const newToken = localStorage.getItem('accessToken');
                config.headers.Authorization = `Bearer ${newToken}`;
            }
        } catch (error) {
            localStorage.removeItem('accessToken');
            localStorage.removeItem('refreshToken');
        }
    }

    return config;
}, (error) => {
    return Promise.reject(error);
})

instance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            localStorage.removeItem('accessToken');
            localStorage.removeItem('refreshToken');
            if (window.location.pathname !== '/login') {
                window.location.href = '/login';
            }
        }
        return Promise.reject(error);
    }
);

export default instance
